<!-- 单品菜品详情 -->
<template>
  <div class="home">
    <van-nav-bar
      :style="{ background: sessionStorage.colorCode }"
      :title="$t('PackageDetail.title')"
      left-arrow
      fixed
      :z-index="9"
      @click-left="$router.go(-1)"
    >
    </van-nav-bar>
    <div v-if="detail" style="margin-top: 47px">
      <div class="dish_content">
        <van-image
          width="130px"
          height="130px"
          @click="ImagePreviewBtn(detail.image.path)"
          :src="detail.image ? detail.image.path : sessionStorage.images"
        />
        <div class="info">
          <div
            class="noExceed"
            style="height: 30px; font-size: 17px; line-height: 30px; font-weight: 600;"
          >
            {{ detail.name }}
          </div>
          <div
            class="noExceed"
            style="font-size: 17px; line-height: 17px; font-weight: 600;"
          >
            {{ detail.name_en }}
          </div>
          <div class="dish_footer">
            <van-rate
              style="height: 16px;"
              v-model="detail.level"
              :size="16"
              gutter="3px"
              icon="./static/img/Recommend-s.png"
              void-icon="./static/img/Recommend.png"
            />

            <div class="fontLine">
              <span class="currentPrice"
                >{{ sessionStorage.getItem("currency") }}
                {{
                  detail.type == "o"
                    ? detail.original_price
                    : detail.special_price
                }}</span
              >&nbsp;&nbsp;&nbsp;<span
                class="oldPrice"
                v-show="detail.type == 's'"
                >{{ sessionStorage.getItem("currency") }}
                {{ detail.original_price }}</span
              >
            </div>
          </div>
          <p>
            {{ detail.introduction }}
          </p>
        </div>
      </div>
      <div style="height: 3px;width: 100%;background-color: #b7b7b7;"></div>
      <div class="tasteGropu">
        <div
          class="tasteItem"
          v-for="(item, index) in detail.perfer.data"
          :key="index"
        >
          <div class="tasteItemTitle">
            {{ item.name }}<span class="required">*</span>
          </div>
          <span
            class="is_choiced1 tag"
            v-if="detail.perfer.data[index].is_choiced == 1"
          >
            <div
              v-for="(val, key) in item.category.data"
              :key="key"
              class="tasteItemRadio"
              :style="
                perferResult[index][key] == val.id
                  ? {
                      border: `1px solid ${sessionStorage.colorCode}`,
                      background: `${sessionStorage.colorCode}`
                    }
                  : { border: `1px solid ${sessionStorage.colorCode}` }
              "
              :class="[
                perferResult[index][key] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, key, val.id)"
            >
              {{ val.name }}
              <span v-if="val.price != 0"
                >{{ sessionStorage.getItem("currency") }} {{ val.price }}</span
              >
            </div>
          </span>
          <span v-else class="tag">
            <div
              v-for="(val, key) in item.category.data"
              :key="key"
              class="tasteItemRadio"
              :style="
                perferResult[index][key] == val.id
                  ? {
                      border: `1px solid ${sessionStorage.colorCode}`,
                      background: `${sessionStorage.colorCode}`
                    }
                  : { border: `1px solid ${sessionStorage.colorCode}` }
              "
              :class="[
                perferResult[index][0] == val.id ? 'tasteItemRadio_act' : ''
              ]"
              @click="changeResult(index, key, val.id)"
            >
              {{ val.name }}
              <span v-if="val.price != 0"
                >{{ sessionStorage.getItem("currency") }} {{ val.price }}</span
              >
            </div>
          </span>
        </div>
        <div class="tasteItem">
          <div class="tasteItemTitle">{{ $t("PackageDetail.remark") }}</div>
          <van-field
            v-model="remark[0]"
            rows="3"
            autosize
            type="textarea"
            maxlength="80"
            :placeholder="$t('PackageDetail.inputRemark')"
            show-word-limit
            style="text-indent: 10px; border: 1px solid #000; border-radius: 5px;"
          />
        </div>
      </div>
    </div>
    <div style="height: 50px;background: #F3F5F7;"></div>
    <!-- 购物车菜品 -->
    <van-popup
      class="ShopCartBox"
      v-model="isShopCartShow"
      position="bottom"
      :style="{ height: '75%' }"
    >
      <van-cell-group class="cartHeader">
        <van-cell>
          <div
            style="font-size: 18px; font-weight: 600; color: #000"
            slot="title"
          >
            <van-icon
              slot="left-icon"
              name="./static/img/toback.png"
              size="16px"
              @click="isShopCartShow = false"
            />
            <!-- {{ $t("Dishes.cart") }} -->
            {{ $t("Dishes.myCart") }}[ {{ shopCart.count }} ]
          </div>
          <van-icon
            slot="right-icon"
            name="./static/img/empty.png"
            size="26px"
            @click="chearShopcart"
          />
        </van-cell>
      </van-cell-group>
      <div class="cartDetail" v-if="shopCart.data">
        <template v-for="(dish, index) in shopCart.data">
          <div class="cartItem" :key="index">
            <!-- 产品 -->
            <div class="cart_dish">
              <div class="dish noExceed">
                <template v-if="dish.image">
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="dish.image.path"
                  />
                </template>
                <template v-else>
                  <van-image
                    class="menuImg"
                    width="70"
                    height="70"
                    :src="sessionStorage.images"
                  />
                </template>
                <div style="margin-left: 10px; width: calc(100% - 80px);">
                  <div class="menu_name">{{ dish.menu_name }}</div>
                  <div class="cart_dish_des noExceed">
                    <template
                      v-if="dish.menus_name.length == 0 && dish.tags_name"
                    >
                      <span
                        v-for="(tagName, index) in dish.tags_name"
                        :key="index"
                      >
                        {{ tagName }}，
                      </span>
                    </template>
                    <span
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                      >{{ $t("PackageDetail.remark") }}：</span
                    >
                    <template
                      v-if="dish.menus_name.length == 0 && dish.remark[0] != ''"
                    >
                      ({{ dish.remark[0] }})
                    </template>
                  </div>
                  <div
                    style="display: flex; align-items: center; justify-content: space-between;"
                  >
                    <div class="realPrice">
                      {{ sessionStorage.getItem("currency") }}{{ dish.price }}
                    </div>
                    <!-- 加减和价格 -->
                    <div class="icon_group">
                      <div class="cart_dish_icon fl">
                        <van-icon
                          class="reduceBtn"
                          :style="{
                            border: `1px solid ${sessionStorage.colorCode}`
                          }"
                          name="./static/img/reduce.png"
                          size="10px"
                          @click="subShopCart(dish.id, dish.number)"
                        ></van-icon>
                        <span
                          style="
                              display: inline-block;
                              min-width: 30px;
                              height: 30px;
                              text-align: center;
                              line-height: 30px;
                              vertical-align: top;
                            "
                        >
                          {{ dish.number }}
                        </span>
                        <van-icon
                          class="addBtn"
                          :style="{ background: sessionStorage.colorCode }"
                          name="./static/img/add.png"
                          size="12px"
                          @click="addShopCart(dish.id)"
                        ></van-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 套餐 -->
              <div v-if="dish.menus_name">
                <div
                  class="cart_dish son_dish"
                  v-for="(menu, key) in dish.menus_name"
                  :key="key"
                >
                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_name noExceed fl"
                  >
                    <template v-for="(menuArr, i) in menu">
                      {{ menuArr }}{{ i == menu.length - 1 ? "" : "、" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_name noExceed fl">
                    {{ menu }}
                  </div>

                  <div
                    v-if="typeof menu == 'object'"
                    class="cart_dish_price noExceed fl"
                  >
                    {{ sessionStorage.getItem("currency") }}
                    <template v-for="(priceArr, j) in dish.fill_price[key]">
                      {{ j == 0 ? priceTotal(dish.fill_price[key]) : "" }}
                    </template>
                  </div>
                  <div v-else class="cart_dish_price noExceed fl">
                    {{ sessionStorage.getItem("currency")
                    }}{{ dish.fill_price[key] }}
                  </div>
                  <div class="cart_dish_des noExceed fl">
                    <template v-if="dish.tags_name[key]">
                      <template v-if="typeof dish.tags_name[key] == 'object'">
                        <template v-for="(tagName, i) in dish.tags_name[key]">
                          <template v-if="typeof tagName == 'object'">
                            {{ arrShow(tagName) }}
                          </template>
                          <template v-else>
                            {{ tagName }}
                          </template>
                          <template v-if="dish.remark[key][i]">
                            ({{ dish.remark[key][i]
                            }}{{
                              i == dish.remark[key].length - 1 ||
                              !dish.remark[key][i]
                                ? ""
                                : ""
                            }})
                          </template>
                          &nbsp;&nbsp;
                        </template>
                      </template>
                      <template v-else>
                        {{ dish.tags_name[key] }}
                        <template v-if="dish.remark[key]">
                          ({{ dish.remark[key] }})
                        </template>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
              <!-- <div v-if="dish.menus_name" class="cart_dish_price noExceed fl">
                  {{ sessionStorage.getItem("currency") }}
                  {{ dish.original_price / dish.number }}
                </div> -->
            </div>
          </div>
          <van-divider style="margin: 10px 0;" />
        </template>
        <div style="height: 50px;"></div>
      </div>
      <!-- <van-tabbar class="flexNone" style="background: #000;">
          <div style="width: 88%; height: 34px; margin: 8px 6%;">
            <div class="cart_left">
              <div class="fl total_price" style="text-indent: 0;">
                {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
              </div>
            </div>
            <div class="cart_right">
              <van-button
                color="#2f75f4"
                class="cart_right_btn"
                round
                @click="placeOrder()"
              >
                {{ $t("Dishes.order") }}
              </van-button>
            </div>
          </div>
        </van-tabbar> -->
      <van-tabbar
        :fixed="true"
        style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
      >
        <div
          style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
        >
          <div class="cart_left" @click="isShopCartShow = true">
            <van-badge :content="shopCart.count">
              <svg-icon
                :style="{
                  width: '34px',
                  height: '34px',
                  filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                  transform: 'translateX(-100px)'
                }"
                iconClass="cart"
                class="icon"
              />
            </van-badge>
          </div>
          <div class="cart_right">
            <div
              class="fl total_price"
              :style="{ color: sessionStorage.colorCode }"
            >
              {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
            </div>
            <!-- 下单按钮 -->
            <van-button
              :color="sessionStorage.colorCode"
              class="cart_right_btn"
              round
              @click="placeOrder()"
            >
              OK
            </van-button>
          </div>
        </div>
      </van-tabbar>
    </van-popup>
    <!-- 底部固定购物车栏 -->
    <van-tabbar
      :fixed="true"
      style="background: #fff; box-shadow: 0px 0px 10px #979797; padding: 0px 0px 10px;"
    >
      <div
        style="width: 88%; height: 45px; padding: 10px 0px 0px; margin: 8px auto; overflow: hidden;"
      >
        <div class="cart_left" @click="isShopCartShow = true">
          <!-- <van-icon
              class="fl"
              name="../assets/icons/svg/cart.svg"
              :badge="shopCart.count"
              @click="isShopCartShow = true"
              size="34px"
            /> -->
          <van-badge :content="shopCart.count">
            <!-- <svg-icon
              v-if="iconshow"
              :style="{
                width: '34px',
                height: '34px',
                filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                transform: 'translateX(-100px)'
              }"
              iconClass="cart"
              class="icon"
            /> -->
            <img
              src="../../static/img/cart.png"
              :style="{
                width: '34px',
                height: '34px',
                '-webkit-filter': `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                filter: `drop-shadow(${sessionStorage.colorCode} 100px 0)`,
                transform: 'translateX(-100px)'
              }"
            />
          </van-badge>
        </div>
        <div class="cart_right">
          <div
            class="fl total_price"
            :style="{ color: sessionStorage.colorCode }"
          >
            {{ sessionStorage.getItem("currency") }}{{ shopCart.total }}
          </div>
          <!-- 添加产品按钮 -->
          <van-button
            :color="sessionStorage.colorCode"
            class="cart_right_btn"
            round
            @click="addCart()"
          >
            <!-- {{ $t("Dishes.order") }} -->
            <van-image
              style="margin-top: 10px"
              width="30"
              height="25"
              src="./static/img/addCart.png"
            />
          </van-button>
        </div>
      </div>
    </van-tabbar>
    <div
      class="inDot"
      :style="{ bottom: bottomNum + 'px', left: leftNum + 'px' }"
      v-show="visible"
    ></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      isTasteShow: false,
      perferResult: [],
      remark: [""],
      //购物车数据
      isShopCartShow: false,
      shopCart: {},
      //动效 声音
      visible: false,
      bottomNum: 33,
      leftNum: 50,
      musicPlayer: new Audio(),
      iconshow: false
    };
  },
  created() {
    this.getDishDetail();
    this.getShopCart();
    this.musicPlayer.src = "./static/music/add_dish.mp3";
    this.musicPlayer.loop = false;
    this.musicPlayer.preload = "auto";
    setTimeout(() => {
      this.iconshow = true;
    }, 1000);
  },
  methods: {
    // 图片预览
    ImagePreviewBtn(imgUrl) {
      if (imgUrl) {
        this.ImagePreview([`${imgUrl}`]);
      }
    },
    // 获取菜品详情
    getDishDetail() {
      this.$axios({
        method: "get",
        url: this.$build + "/api/menu/" + this.$route.params.id + "/takeIndex"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.detail = res.data.data;
            for (var i = 0; i < this.detail.perfer.data.length; i++) {
              if (this.detail.perfer.data[i].category.data.length > 0) {
                // this.perferResult.push(
                //   this.detail.perfer.data[i].category.data[0].id
                // );
                this.perferResult[i] = [];
                this.perferResult[i].push(
                  this.detail.perfer.data[i].category.data[0].id
                );
                console.log(this.perferResult);
              }
              // console.log(this.perferResult)
            }
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 判断数组的值是否全为空
    areAllValuesEmpty(array) {
      return array.every(
        value =>
          value === null ||
          value === undefined ||
          value === "" ||
          value === 0 ||
          value === false
      );
    },
    // 选择偏好标签
    changeResult(index, key, id) {
      // console.log(index, key, id);
      // this.detail.perfer.data[index].is_choiced = 1;
      if (this.detail.perfer.data[index].is_choiced == 1) {
        let arr = JSON.parse(JSON.stringify(this.perferResult[index]));
        let type = arr.indexOf(id);
        type == -1 ? (arr[key] = id) : arr.splice(type, 1, "");
        if (!this.areAllValuesEmpty(arr)) {
          this.$set(this.perferResult, index, arr);
        }
      } else {
        let arr = this.perferResult[index];
        arr[0] = id;
        this.$set(this.perferResult, index, arr);
      }
    },
    // 加入购物车
    addCart() {
      var perferIds = [];
      let arr = [];
      this.perferResult.forEach((item, i) => {
        if (item.length == 1) {
          arr[i] = item[0];
        } else {
          arr[i] = JSON.parse(JSON.stringify(item));
          arr[i].forEach((j, num) => {
            if (j == "") {
              arr[i].splice(num, 1);
            }
          });
        }
      });
      console.log(arr);
      // perferIds.push(this.perferResult);
      perferIds.push(arr);
      this.$axios({
        method: "post",
        url: this.$build + "/api/shopcart/takeStore",
        data: {
          code: localStorage.onlyCode,
          menu_id: this.$route.params.id,
          tags_id: JSON.stringify(perferIds),
          remark: JSON.stringify(this.remark)
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.addAnimation();
            this.musicPlayer.currentTime = 0;
            this.musicPlayer.play();
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 获取购物车详情
    getShopCart() {
      // 获取
      this.$axios({
        method: "post",
        url: this.$build + "/api/place/takeShopcart",
        data: {
          code: localStorage.onlyCode
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.shopCart = res.data;
            this.shopCart.data.forEach(item => {
              let arr = [];
              if (item.menus_name.length != 0 && item.tags_name) {
                // 套餐偏好重新排版
                item.tags_name.forEach((i, num) => {
                  i.forEach((j, index) => {
                    let list = []; //临时存储
                    if (i.length > 1) {
                      list.push(`(${item.menus_name[num][index]})：`);
                    }
                    if (typeof j == "object") {
                      j.forEach(tag => {
                        list.push(tag);
                      });
                    } else {
                      list.push(j);
                    }
                    i.splice(index, 1, list);
                  });
                });
              } else if (item.menus_name.length == 0 && item.tags_name) {
                // 单品偏好重新排版
                if (item.tags_name[0] != "") {
                  item.tags_name.forEach(i => {
                    i.forEach(j => {
                      console.log(j);
                      if (typeof j == "object") {
                        j.forEach(tag => {
                          arr.push(tag);
                        });
                      } else {
                        arr.push(j);
                      }
                    });
                  });
                }
                item.tags_name = arr;
              }
            });
          } else {
            // for (var item in res.data.error) {
            //   this.$toast({
            //     duration: 1000,
            //     type: "fail",
            //     message: res.data.error[item]
            //   });
            // }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 增加商品
    addShopCart(id) {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
        data: {
          type: "add"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getShopCart();
          } else {
            this.$toast.allowMultiple();
            for (var item in res.data.error) {
              this.$toast({
                duration: 1000,
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 减少商品
    subShopCart(id, number) {
      if (number == 1) {
        this.$dialog
          .confirm({
            title: this.$t("Dishes.del"),
            message: this.$t("Dishes.isDel"),
            confirmButtonColor: "#FFC813",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "PATCH",
              url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
              data: {
                type: "reduce"
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.getShopCart();
                } else {
                  this.$toast.allowMultiple();
                  for (var item in res.data.error) {
                    this.$toast({
                      duration: 1000,
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: this.$t("common.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$axios({
          method: "PATCH",
          url: this.$build + "/api/shopcart/" + id + "/takeUpdate",
          data: {
            type: "reduce"
          }
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.getShopCart();
            } else {
              this.$toast.allowMultiple();
              for (var item in res.data.error) {
                this.$toast({
                  duration: 1000,
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              duration: 1000,
              type: "fail",
              message: this.$t("common.message")
            });
          });
      }
    },
    // 下单
    placeOrder() {
      this.$axios({
        method: "PATCH",
        url: this.$build + "/api/place/takeOrder",
        data: {
          code: localStorage.onlyCode,
          store_id: sessionStorage.storeId,
          type: "1"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            localStorage.setItem("takeOrderId", res.data.id);
            var vm = this;
            setTimeout(() => {
              vm.$router.push("/PackOrderDetail/" + res.data.id);
            }, 500);

            localStorage.setItem("successCode", localStorage.onlyCode);
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("common.message")
          });
        });
    },
    // 动效
    addAnimation() {
      this.visible = true;
      this.bottomNum = 33;
      this.leftNum = 250;
      var that = this;
      var timer = setInterval(function() {
        if (that.leftNum > 150 && that.bottomNum < 133) {
          that.bottomNum += 5;
        } else if (that.leftNum <= 150 && that.bottomNum > 33) {
          that.bottomNum -= 5;
        } else {
          that.bottomNum = 33;
          that.visible = false;
          clearInterval(timer);
        }
        if (that.leftNum > 50) {
          that.leftNum -= 5;
        } else {
          that.leftNum = 50;
        }
      }, 10);
    },
    backBtn() {
      this.isShopCartShow = false;
      this.$router.go(-1);
    },
    // 清空购物车
    chearShopcart() {
      this.$axios({
        method: "DELETE",
        url: this.$build + "/api/shopcart/takeClear",
        data: {
          code: localStorage.getItem("onlyCode")
        }
      })
        .then(res => {
          if (res.data.status == 200) {
            this.getShopCart();
            this.getDishes();
            this.$toast({
              type: "success",
              message: res.data.message,
              duration: 1000
            });
          } else {
            this.$toast.allowMultiple();
          }
        })
        .catch(err => {
          this.$toast({
            duration: 1000,
            type: "fail",
            message: this.$t("common.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 26px;
  color: #fff;
}
/deep/ .van-field__body > input {
  text-align: right;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  color: #2f75f4;
}
/deep/ .van-divider {
  border-width: 2px;
}
/deep/ .van-info {
  border-color: #000;
}
/deep/ .dish_content .van-image {
  padding: 5px 10px 10px;
}
/deep/ .van-image img {
  border-radius: 10px;
  max-width: 25rem;
  margin: 0 auto;
}
/deep/ .ShopCartBox .van-popup .van-cell {
  position: fixed;
  z-index: 999;
}
/deep/ .tasteItem .van-cell {
  text-indent: 10px;
  border-radius: 5px;
}
.required {
  color: #ee0a24;
  font-size: 20px;
  font-weight: 600;
  position: relative;
  top: 5px;
  left: 5px;
}
.dish_content {
  display: flex;
}
.dish_footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 5px;
}
.menuImg {
  vertical-align: middle;
}
.home {
  width: 100%;
  height: auto;
  background-color: #fff;
}
.currentPrice {
  font-size: 20px;
  font-weight: 600;
  color: #fe2a00;
}
.oldPrice {
  color: #bcbcbc;
  text-decoration: line-through;
}
.info {
  width: calc(90% - 110px);
  height: auto;
  position: relative;
}
.info p {
  font-size: 14px;
  color: #666;
  padding: 0;
  margin-bottom: 10px;
  margin-top: 0px;
  word-break: break-all;
}
.fontLine {
  padding-bottom: 10px;
  font-size: 14px;
}
.setPerfer {
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 10px;
  right: 0px;
}
.setPerfer span {
  position: absolute;
  font-size: 12px;
  top: 16px;
  left: 7px;
}
.flexNone {
  flex: none;
}
.cart_left {
  width: 60%;
  height: 34px;
  line-height: 34px;
  font-size: 18px;
  float: left;
}
.cart_right {
  width: 30%;
  height: 34px;
  line-height: 26px;
  float: right;
  text-align: right;
  display: flex;
  justify-content: right;
}
.cart_right_btn {
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  color: #222;
  padding: 5px 35px;
  font-weight: 600;
  font-size: 18px;
}
.total_price {
  height: 34px;
  line-height: 34px;
  text-indent: 10px;
  font-size: 20px;
  font-weight: 600;
  text-align: right;
  margin-right: 10px;
}
.tasteGropu {
  width: 90%;
  margin-left: 5%;
  font-size: 16px;
  height: calc(80vh - 9.6875rem);
  overflow-y: auto;
  padding-bottom: 70px;
}
.tasteItem {
  width: 100%;
  height: auto;
  color: #222;
}
.tasteItemTitle {
  width: 100%;
  height: 45px;
  line-height: 45px;
}
.tag {
  display: flex;
}
.tasteItemRadio {
  width: 100%;
  height: 33px;
  line-height: 33px;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid #2f75f4;
  text-align: center;
  margin-bottom: 20px;
  margin-right: 10px;
}
.tasteItemRadio_act {
  background-color: #2f75f4;
  color: #fff;
}
.van-button__text {
  color: #fff;
}
.cartHeader {
  width: 100%;
  position: fixed;
  background: #fff;
  z-index: 10;
}
.cartDetail {
  width: 100%;
  height: auto;
  margin-top: 50px;
}
.cartItem {
  width: 90%;
  margin-left: 5%;
  position: relative;
}
.cart_dish {
  width: 100%;
  overflow: hidden;
}
.cart_dish_name {
  width: 80%;
  height: 50px;
  line-height: 50px;
  text-indent: 5px;
}
.cart_dish_icon {
  width: 80%;
  height: 40px;
  line-height: 40px;
}
.cart_dish_price {
  width: 20%;
  height: 35px;
  line-height: 35px;
  text-align: right;
  color: #aaa;
}
.cart_dish_des {
  width: 100%;
  height: 20px;
  line-height: 20px;
  font-size: 13px;
  color: #ccc;
}
.dish {
  display: flex;
}
.son_dish > .cart_dish_name {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_price {
  height: 20px;
  line-height: 20px;
  font-size: 14px;
}
.son_dish > .cart_dish_des {
  height: 18px;
  line-height: 18px;
  font-size: 12px;
}
.icon_group {
  height: 35px;
  line-height: 35px;
}
.realPrice {
  color: #fb2525;
  font-weight: 600;
}
.inDot {
  width: 24px;
  height: 24px;
  background: #ee0a24;
  border-radius: 50%;
  position: fixed;
  z-index: 2;
}
.mright {
  position: absolute;
  right: 0.625rem;
}
.mleft {
  position: absolute;
  right: 6.25rem;
}
@media screen and (min-width: 480px) {
  .mright {
    position: absolute;
    right: 2.5rem;
  }
  .mleft {
    position: absolute;
    right: 8.75rem;
  }
}
.reduceBtn,
.addBtn {
  border-radius: 8px;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/packDishes/PackDishesDetail.vue